/* eslint-disable react/style-prop-object */
import React, { memo } from 'react';

const SvgIcon = memo(({ width, height, viewBox, children, className, ariaLabel }) => (
  <svg
    aria-label={ariaLabel}
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox={viewBox}
    className={className}
  >
    {children}
  </svg>
));

export const IconPlay = ({ className, width = '16.03', height = '20.75', color = '#0a0824' }) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 16.03 20.75'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      fill={color}
      fillRule='evenodd'
      d='M1040.06,599.708V578.96l16.04,10.374Z'
      transform='translate(-1040.06 -578.969)'
    />
  </SvgIcon>
);

export const IconPlayCircle = ({
  className,
  width = '45px',
  height = '45px',
  backgroundColor = 'rgb(254, 237, 0)',
  playColor = 'rgb(10, 8, 36)',
}) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 45 45'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      fillRule='evenodd'
      fill={backgroundColor}
      className='background-path'
      d='M22.266,-0.000 C34.563,-0.000 44.531,9.969 44.531,22.266 C44.531,34.563 34.563,44.531 22.266,44.531 C9.969,44.531 0.000,34.563 0.000,22.266 C0.000,9.969 9.969,-0.000 22.266,-0.000 Z'
    />
    <path
      fillRule='evenodd'
      fill={playColor}
      className='play-path'
      d='M17.063,32.708 L17.063,11.960 L33.097,22.334 L17.063,32.708 Z'
    />
  </SvgIcon>
);

export const IconPlayCircleEpisode = ({
  className,
  width = '46px',
  height = '46px',
  backgroundColor = 'rgb(0, 29, 72)',
  playColor = 'rgb(254, 237, 0)',
}) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 46 46'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      fillRule='evenodd'
      fill={backgroundColor}
      d='M23.094,0.594 C35.520,0.594 45.594,10.667 45.594,23.094 C45.594,35.520 35.520,45.594 23.094,45.594 C10.667,45.594 0.594,35.520 0.594,23.094 C0.594,10.667 10.667,0.594 23.094,0.594 Z'
    />
    <path
      fillRule='evenodd'
      fill={playColor}
      d='M17.998,32.000 L17.998,14.362 L31.629,23.181 L17.998,32.000 Z'
    />
  </SvgIcon>
);

export const IconCheck = ({
  className,
  width = '31.124',
  height = '21.719',
  color = '#feed00',
}) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 31.124 21.719'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      fill={color}
      fillRule='evenodd'
      d='M647.46,328.291l15.42-15.382,3.183,3.172-18.6,18.557L634.938,322.17,638.121,319Z'
      transform='translate(-634.938 -312.906)'
    />
  </SvgIcon>
);

export const IconCheckCircle = ({
  className,
  width = '46.5px',
  height = '46.5px',
  color = '#feed00',
}) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 46.5 46.5'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      className='check-circle'
      fillRule='evenodd'
      stroke={color}
      strokeWidth='1px'
      strokeLinecap='butt'
      strokeLinejoin='miter'
      fill='none'
      d='M23.000,0.500 C35.426,0.500 45.500,10.574 45.500,23.000 C45.500,35.426 35.426,45.500 23.000,45.500 C10.574,45.500 0.500,35.426 0.500,23.000 C0.500,10.574 10.574,0.500 23.000,0.500 Z'
    />
    <path
      className='check-path'
      fillRule='evenodd'
      fill={color}
      d='M20.458,26.218 L30.870,15.831 L33.019,17.973 L20.458,30.503 L12.003,22.085 L14.152,19.943 L20.458,26.218 Z'
    />
  </SvgIcon>
);

export const IconContinueWatch = ({
  className,
  width = '24.188',
  height = '21.719',
  color = '#feed00',
}) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 24.188 21.719'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      fill={color}
      fillRule='evenodd'
      d='M956.667,334.852l15.762-10.861L956.667,313.13v21.722Zm-8.422-21.722v21.722h3.986V313.13h-3.986Z'
      transform='translate(-948.25 -313.125)'
    />
  </SvgIcon>
);

export const IconPurchases = ({
  className,
  width = '29.47',
  height = '30.376',
  color = '#feed00',
}) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 29.47 30.376'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      fill={color}
      fillRule='evenodd'
      d='M1282.53,317.533h-3.79a8.285,8.285,0,0,0-16.57,0h-3.79l-2.66,22.14h29.46Zm-12.08-5.14a5.172,5.172,0,0,1,5.19,5.14h-10.37A5.163,5.163,0,0,1,1270.45,312.393Zm-11.24,24.212,1.92-16h18.65l1.92,16h-22.49Z'
      transform='translate(-1255.72 -309.312)'
    />
  </SvgIcon>
);

export const IconTerms = ({ className, width = '23.53', height = '27', color = '#feed00' }) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 23.53 27'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      fill={color}
      fillRule='evenodd'
      d='M1103.89,460.938v27h23.53v-27h-23.53Zm20.8,24.271h-18.07V463.667h18.07v21.542Zm-3.86-17.23h-10.35v2.728h10.35v-2.728Zm0,6.968h-10.35v2.728h10.35v-2.728Z'
      transform='translate(-1103.88 -460.938)'
    />
  </SvgIcon>
);

export const IconPrivacy = ({
  className,
  width = '27.594',
  height = '29.813',
  color = '#feed00',
}) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 27.594 29.813'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      fill={color}
      fillRule='evenodd'
      d='M791.209,474.567c1,7.451,5.972,13.26,12.158,14.055V474.567H791.209Zm15.08,0v14.055c6.187-.8,11.154-6.608,12.155-14.055H806.289Zm0-15.74v12.809H818.63V463.97A27.238,27.238,0,0,1,806.289,458.827Zm-15.266,5.143v7.666h12.344V458.827A27.264,27.264,0,0,1,791.023,463.97Z'
      transform='translate(-791.031 -458.812)'
    />
  </SvgIcon>
);

export const IconPluse = ({ className, width = '18.875', height = '18.88', color = '#8195b3' }) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 18.875 18.88'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      fill={color}
      fillRule='evenodd'
      d='M826.318,1939.02h-2.329v8.28H815.71l0,2.33h8.277v8.27h2.329v-8.27H834.6v-2.33h-8.277v-8.28Z'
      transform='translate(-815.719 -1939.03)'
    />
  </SvgIcon>
);

export const IconPluseCircle = ({
  className,
  width = '46.5px',
  height = '46.5px',
  color = 'rgb(255, 255, 255)',
}) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 46.5 46.5'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      fillRule='evenodd'
      stroke={color}
      strokeWidth='1px'
      strokeLinecap='butt'
      strokeLinejoin='miter'
      fill='none'
      className='pluse-circle'
      d='M23.000,0.500 C35.426,0.500 45.500,10.574 45.500,23.000 C45.500,35.426 35.426,45.500 23.000,45.500 C10.574,45.500 0.500,35.426 0.500,23.000 C0.500,10.574 10.574,0.500 23.000,0.500 Z'
    />
    <path
      className='pluse-path'
      fillRule='evenodd'
      fill={color}
      d='M24.289,12.511 L21.701,12.510 L21.701,21.711 L12.500,21.711 L12.501,24.299 L21.701,24.299 L21.701,33.499 L24.289,33.500 L24.289,24.299 L33.490,24.299 L33.489,21.711 L24.289,21.711 L24.289,12.511 Z'
    />
  </SvgIcon>
);

export const IconSync = ({ className, width = '17.375', height = '17.97', color = '#8195b3' }) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 17.375 17.97'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      fill={color}
      fillRule='evenodd'
      d='M833.529,2029.66l-6-5.89v3.14H816.15v2.75h17.379Zm-17.379,6.22,6,5.88v-3.13h11.379v-2.75H816.15Z'
      transform='translate(-816.156 -2023.78)'
    />
  </SvgIcon>
);

export const IconBackArrow = ({
  className,
  width = '21.5',
  height = '20.656',
  color = '#8195b3',
}) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 21.5 20.656'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      fill={color}
      fillRule='evenodd'
      d='M3287.48,309.727H3272.1l6.45-6.459L3276.29,301l-10.32,10.33,10.32,10.33,2.26-2.269-6.45-6.458h15.38v-3.205Z'
      transform='translate(-3265.97 -301)'
    />
  </SvgIcon>
);

export const IconVolume = ({ className, width = '46.5', height = '46.5', color = '#fff' }) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 46.5 46.5'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <circle fill='none' cx='22.5' cy='22.5' r='22.5' />
    <g>
      <path
        id='sound-2'
        data-name='sound'
        fill={color}
        fillRule='evenodd'
        d='M27,22.941a5.043,5.043,0,0,0-2.778-4.514v9.033A5.058,5.058,0,0,0,27,22.941ZM12,19.577v6.729h4.445L22,31.913V13.97l-5.557,5.607H12ZM24.22,13.106v2.316a7.866,7.866,0,0,1,0,15.038v2.316A10.107,10.107,0,0,0,24.22,13.106Z'
      />
    </g>
  </SvgIcon>
);

export const IconVolumeMuted = ({ className, width = '46.5', height = '46.5', color = '#fff' }) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 46.5 46.5'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <circle fill='none' cx='22.5' cy='22.5' r='22.5' />
    <g>
      <path
        id='no_sound'
        fill={color}
        fillRule='evenodd'
        d='M27,22.782a4.99,4.99,0,0,0-2.778-4.471v2.455l2.728,2.727A5.027,5.027,0,0,0,27,22.782Zm2.778,0a7.679,7.679,0,0,1-.6,2.932L30.86,27.4a9.972,9.972,0,0,0-6.64-14.356v2.294A7.775,7.775,0,0,1,29.777,22.782ZM22,13.9l-2.323,2.322L22,18.539V13.9Zm-8.585-1.111L12,14.2l5.251,5.248H12v6.664h4.445L22,31.668V24.2l4.728,4.726a7.831,7.831,0,0,1-2.506,1.311v2.294a9.971,9.971,0,0,0,4.095-2.01l2.267,2.26L32,31.362l-10-10Z'
      />
    </g>
  </SvgIcon>
);

export const IconClose = ({
  className,
  width = '30px',
  height = '30px',
  color = 'rgba(0, 29, 72, 0.5)',
  innerColor = 'rgb(255, 255, 255)',
}) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 30 30'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      fillRule='evenodd'
      opacity='0.502'
      fill={color}
      d='M15.000,-0.000 C23.284,-0.000 30.000,6.716 30.000,15.000 C30.000,23.284 23.284,30.000 15.000,30.000 C6.716,30.000 0.000,23.284 0.000,15.000 C0.000,6.716 6.716,-0.000 15.000,-0.000 Z'
    />
    <path
      className='close-path'
      fillRule='evenodd'
      fill={innerColor}
      d='M22.004,9.533 L20.469,7.997 L15.009,13.457 L9.549,7.997 L8.014,9.533 L13.473,14.993 L8.014,20.454 L9.549,21.990 L15.009,16.530 L20.469,21.990 L22.004,20.454 L16.545,14.993 L22.004,9.533 Z'
    />
  </SvgIcon>
);

export const IconSocialFb = ({ className, width = '8.002', height = '17', color = '#fff' }) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 8.002 17'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      d='M1879.73,2939.292v2.34H1878v2.862h1.729V2953h3.553v-8.5h2.384s.223-1.372.332-2.873h-2.7v-1.958a.835.835,0,0,1,.771-.685H1886V2936h-2.633c-3.728,0-3.64,2.865-3.64,3.292Zm0,0'
      transform='translate(-1878.001 -2936)'
      fill={color}
    />
  </SvgIcon>
);

export const IconSocialIn = ({
  className,
  width = '17.996',
  height = '17.997',
  color = '#fff',
}) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 14.996 14.997'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      d='M1989.361,2952a4.361,4.361,0,0,1-4.356-4.357v-6.284a4.361,4.361,0,0,1,4.356-4.356h6.284a4.361,4.361,0,0,1,4.356,4.356v6.284a4.361,4.361,0,0,1-4.356,4.357Zm-3.185-10.641v6.284a3.189,3.189,0,0,0,3.185,3.185h6.284a3.188,3.188,0,0,0,3.184-3.185v-6.284a3.188,3.188,0,0,0-3.184-3.184h-6.284A3.188,3.188,0,0,0,1986.176,2941.358Zm2.285,3.142a4.042,4.042,0,1,1,4.042,4.042A4.046,4.046,0,0,1,1988.461,2944.5Zm1.172,0a2.871,2.871,0,1,0,2.87-2.871A2.873,2.873,0,0,0,1989.633,2944.5Zm6.377-4.1a.59.59,0,1,1,.589.591A.589.589,0,0,1,1996.01,2940.4Z'
      transform='translate(-1985.005 -2937.001)'
      fill={color}
    />
  </SvgIcon>
);

export const IconSocialTw = ({
  className,
  width = '20.003',
  height = '20.001',
  color = '#fff',
}) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 17.003 14.001'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      d='M1944.014,2939.641a6.9,6.9,0,0,1-2,.559,3.55,3.55,0,0,0,1.536-1.958,6.891,6.891,0,0,1-2.221.858,3.464,3.464,0,0,0-2.543-1.115,3.513,3.513,0,0,0-3.487,3.534,3.734,3.734,0,0,0,.089.805,9.86,9.86,0,0,1-7.192-3.694,3.568,3.568,0,0,0,1.079,4.719,3.4,3.4,0,0,1-1.577-.442v.043a3.533,3.533,0,0,0,2.8,3.471,3.522,3.522,0,0,1-.917.12,3.466,3.466,0,0,1-.66-.062,3.507,3.507,0,0,0,3.258,2.456,6.945,6.945,0,0,1-4.333,1.509,7.371,7.371,0,0,1-.83-.047,9.772,9.772,0,0,0,5.349,1.589,9.927,9.927,0,0,0,9.921-10.056l-.011-.457a7.081,7.081,0,0,0,1.744-1.833Zm0,0'
      transform='translate(-1927.011 -2937.986)'
      fill={color}
    />
  </SvgIcon>
);

export const IconDown = ({
  className,
  width = '12px',
  height = '8px',
  color = 'rgb(98, 100, 107)',
}) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 12 8'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      fillRule='evenodd'
      fill={color}
      d='M5.872,4.742 L10.395,0.202 L11.668,1.479 L5.872,7.298 L0.076,1.479 L1.349,0.202 L5.872,4.742 Z'
    />
  </SvgIcon>
);

export const IconSearch = ({ className, width = '20.09', height = '20.094', color = '#fff' }) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 20.09 20.094'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      id='search'
      fill={color}
      fillRule='evenodd'
      d='M1670.33,231.083l-0.51-.506h0l-4.42-4.421a8.521,8.521,0,1,0-1.38,1.378l4.42,4.421h0l0.51,0.506Zm-16.25-5.569a6.575,6.575,0,1,1,9.3,0A6.587,6.587,0,0,1,1654.08,225.514Z'
      transform='translate(-1650.22 -212.375)'
    />
  </SvgIcon>
);

export const IconGuest = ({ className, width = '15', height = '20', color = 'rgb(0, 0, 0)' }) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 17 20'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      fillRule='evenodd'
      fill={color}
      d='M8.415,13.405 C4.714,13.405 1.713,10.405 1.713,6.704 C1.713,3.002 4.714,0.002 8.415,0.002 C12.116,0.002 15.116,3.002 15.116,6.704 C15.116,10.405 12.116,13.405 8.415,13.405 ZM8.415,1.675 C5.642,1.675 3.386,3.930 3.386,6.704 C3.386,9.476 5.642,11.732 8.415,11.732 C11.188,11.732 13.444,9.476 13.444,6.704 C13.444,3.930 11.188,1.675 8.415,1.675 ZM16.146,18.746 L14.965,19.926 C13.503,18.620 11.087,17.749 8.415,17.749 C5.744,17.749 3.329,18.620 1.866,19.926 L0.683,18.746 C2.451,17.125 5.256,16.076 8.415,16.076 C11.575,16.076 14.378,17.123 16.146,18.746 Z'
    />
  </SvgIcon>
);

export const IconKickstar = ({
  className,
  width = '131',
  height = '15',
  color = 'rgb(255, 255, 255)',
}) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 131 15'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      fillRule='evenodd'
      fill={color}
      d='M129.825,10.882 C130.131,11.375 130.298,11.869 130.298,12.389 C130.298,13.048 130.076,13.595 129.601,14.033 C129.128,14.472 128.570,14.692 127.901,14.692 C127.037,14.692 126.395,14.335 125.949,13.623 L123.970,10.415 L123.970,12.334 C123.970,12.992 123.746,13.540 123.301,14.006 C122.854,14.472 122.297,14.692 121.628,14.692 C120.820,14.692 120.178,14.417 119.761,13.815 C119.370,13.322 119.202,12.636 119.202,11.814 L119.202,3.070 C119.202,1.261 120.178,0.384 122.158,0.384 L125.197,0.384 C126.200,0.384 127.120,0.658 127.957,1.234 C128.821,1.809 129.434,2.522 129.825,3.426 C130.131,4.112 130.270,4.797 130.270,5.482 C130.270,6.770 129.741,7.976 128.709,9.100 L129.825,10.882 ZM115.578,10.196 C116.470,10.196 117.140,10.388 117.586,10.744 C118.088,11.183 118.366,11.731 118.366,12.417 C118.366,13.101 118.116,13.677 117.586,14.088 C117.196,14.417 116.527,14.581 115.607,14.581 L111.899,14.581 C111.035,14.581 110.421,14.528 110.087,14.390 C109.445,14.143 109.028,13.704 108.833,13.129 C108.693,12.745 108.637,12.143 108.637,11.292 L108.637,3.563 C108.637,2.906 108.665,2.495 108.693,2.275 C108.777,1.837 108.944,1.453 109.251,1.124 C109.585,0.768 110.032,0.549 110.533,0.439 C110.784,0.384 111.285,0.384 112.039,0.384 L114.882,0.384 C115.663,0.384 116.109,0.384 116.248,0.412 C116.749,0.466 117.168,0.603 117.502,0.850 C118.088,1.289 118.366,1.837 118.366,2.522 C118.366,3.262 118.116,3.838 117.614,4.249 C117.168,4.605 116.554,4.769 115.775,4.769 L113.432,4.769 L113.432,5.729 L115.300,5.729 C115.857,5.729 116.304,5.866 116.666,6.167 C117.056,6.469 117.224,6.880 117.224,7.428 C117.224,8.552 116.527,9.128 115.133,9.128 L113.432,9.128 L113.432,10.196 L115.578,10.196 ZM105.153,4.769 L104.066,4.769 L104.066,11.842 C104.066,12.608 103.927,13.211 103.675,13.623 C103.230,14.335 102.560,14.692 101.724,14.692 C100.860,14.692 100.219,14.362 99.744,13.732 C99.466,13.322 99.299,12.718 99.299,11.895 L99.299,4.742 L98.044,4.742 C97.347,4.742 96.762,4.550 96.316,4.194 C95.842,3.783 95.591,3.262 95.591,2.577 C95.591,2.166 95.703,1.782 95.926,1.426 C96.148,1.042 96.455,0.795 96.818,0.631 C97.180,0.466 98.044,0.384 99.411,0.384 L104.205,0.384 C105.376,0.384 106.156,0.466 106.491,0.603 C106.881,0.768 107.188,1.014 107.411,1.398 C107.633,1.782 107.773,2.166 107.773,2.577 C107.773,3.235 107.523,3.783 106.993,4.249 C106.631,4.578 106.017,4.769 105.153,4.769 ZM95.228,12.389 C95.228,13.048 95.006,13.595 94.532,14.033 C94.058,14.472 93.500,14.692 92.831,14.692 C91.967,14.692 91.326,14.335 90.879,13.623 L88.900,10.415 L88.900,12.334 C88.900,12.992 88.678,13.540 88.231,14.006 C87.786,14.472 87.227,14.692 86.559,14.692 C85.750,14.692 85.109,14.417 84.691,13.815 C84.301,13.322 84.134,12.636 84.134,11.814 L84.134,3.070 C84.134,1.261 85.109,0.384 87.089,0.384 L90.127,0.384 C91.131,0.384 92.051,0.658 92.887,1.234 C93.751,1.809 94.364,2.522 94.755,3.426 C95.062,4.112 95.200,4.797 95.200,5.482 C95.200,6.770 94.671,7.976 93.639,9.100 L94.755,10.882 C95.062,11.375 95.228,11.869 95.228,12.389 ZM80.733,14.692 C80.119,14.692 79.617,14.500 79.199,14.143 C78.893,13.869 78.586,13.403 78.279,12.772 L73.846,12.772 L73.846,12.745 C73.624,13.267 73.401,13.677 73.150,13.925 C72.676,14.445 72.090,14.692 71.394,14.692 C70.557,14.692 69.888,14.362 69.442,13.704 C69.164,13.322 69.024,12.855 69.024,12.362 C69.024,11.950 69.136,11.540 69.330,11.128 L73.846,1.672 C74.293,0.740 75.018,0.301 76.049,0.301 C77.081,0.301 77.833,0.768 78.279,1.727 L82.851,11.238 C83.046,11.621 83.130,12.005 83.130,12.362 C83.130,12.910 82.935,13.403 82.573,13.842 C82.098,14.417 81.485,14.692 80.733,14.692 ZM68.132,4.769 L67.045,4.769 L67.045,11.842 C67.045,12.608 66.905,13.211 66.654,13.623 C66.209,14.335 65.539,14.692 64.703,14.692 C63.838,14.692 63.198,14.362 62.724,13.732 C62.445,13.322 62.278,12.718 62.278,11.895 L62.278,4.742 L61.023,4.742 C60.327,4.742 59.741,4.550 59.295,4.194 C58.821,3.783 58.570,3.262 58.570,2.577 C58.570,2.166 58.681,1.782 58.905,1.426 C59.128,1.042 59.435,0.795 59.797,0.631 C60.159,0.466 61.023,0.384 62.389,0.384 L67.184,0.384 C68.354,0.384 69.136,0.466 69.470,0.603 C69.860,0.768 70.166,1.014 70.390,1.398 C70.613,1.782 70.753,2.166 70.753,2.577 C70.753,3.235 70.501,3.783 69.972,4.249 C69.609,4.578 68.996,4.769 68.132,4.769 ZM56.758,6.770 C57.734,7.565 58.208,8.661 58.208,10.088 C58.208,11.649 57.678,12.855 56.591,13.732 C55.587,14.555 54.277,14.938 52.660,14.938 C51.044,14.938 49.706,14.528 48.646,13.677 C47.810,12.992 47.364,12.224 47.364,11.320 C47.364,10.717 47.559,10.224 47.977,9.812 C48.423,9.429 48.925,9.209 49.538,9.209 C50.067,9.209 50.625,9.429 51.238,9.895 C51.991,10.470 52.493,10.744 52.771,10.744 C53.190,10.744 53.385,10.525 53.385,10.114 C53.385,9.895 53.273,9.703 53.023,9.538 C52.883,9.457 52.186,9.182 50.876,8.744 C48.757,8.004 47.698,6.661 47.698,4.660 C47.698,3.152 48.256,1.974 49.371,1.124 C50.374,0.384 51.573,0.000 53.023,0.000 C54.277,0.000 55.364,0.301 56.284,0.877 C57.204,1.453 57.678,2.220 57.678,3.152 C57.678,3.701 57.511,4.166 57.148,4.550 C56.786,4.934 56.340,5.098 55.783,5.098 C55.197,5.098 54.556,4.824 53.831,4.276 C53.385,3.947 53.051,3.755 52.827,3.755 C52.437,3.755 52.242,3.947 52.242,4.304 C52.242,4.660 52.716,4.989 53.691,5.263 C55.029,5.674 56.033,6.167 56.758,6.770 ZM44.158,14.692 C43.433,14.692 42.875,14.472 42.485,14.006 L38.861,9.566 L38.861,12.033 C38.861,12.745 38.749,13.267 38.499,13.677 C38.052,14.390 37.383,14.746 36.519,14.746 C35.739,14.746 35.125,14.500 34.707,13.978 C34.317,13.513 34.094,12.855 34.094,12.088 L34.094,2.906 C34.094,2.166 34.289,1.535 34.707,1.042 C35.181,0.549 35.766,0.274 36.519,0.274 C37.244,0.274 37.830,0.521 38.331,1.042 C38.610,1.315 38.777,1.618 38.833,1.892 C38.889,2.083 38.889,2.412 38.889,2.906 L38.889,5.181 L41.565,1.343 C42.067,0.631 42.736,0.274 43.544,0.274 C44.213,0.274 44.771,0.494 45.245,0.960 C45.719,1.426 45.970,1.974 45.970,2.604 C45.970,3.070 45.830,3.481 45.579,3.865 L43.154,7.318 L46.109,11.018 C46.416,11.375 46.555,11.814 46.555,12.307 C46.555,12.965 46.332,13.513 45.858,13.978 C45.384,14.445 44.827,14.692 44.158,14.692 ZM26.651,10.251 C27.292,10.251 27.905,10.032 28.463,9.593 C28.797,9.264 29.159,8.935 29.494,8.606 C29.857,8.305 30.331,8.141 30.888,8.141 C31.529,8.141 32.087,8.360 32.588,8.799 C33.063,9.237 33.313,9.785 33.313,10.415 C33.313,11.292 32.784,12.171 31.752,13.048 C30.303,14.307 28.630,14.910 26.706,14.910 C25.535,14.910 24.421,14.664 23.361,14.171 C22.051,13.540 20.992,12.636 20.211,11.430 C19.430,10.224 19.040,8.908 19.040,7.455 C19.040,5.318 19.849,3.481 21.465,1.974 C22.888,0.686 24.615,0.028 26.679,0.000 C28.435,0.000 30.052,0.576 31.529,1.727 C32.672,2.632 33.258,3.591 33.258,4.578 C33.258,5.400 32.895,6.058 32.198,6.524 C31.808,6.798 31.362,6.907 30.888,6.907 C30.498,6.907 30.135,6.825 29.773,6.633 C29.633,6.551 29.271,6.195 28.686,5.592 C28.156,5.016 27.459,4.715 26.651,4.715 C25.870,4.715 25.201,4.989 24.671,5.510 C24.141,6.058 23.863,6.716 23.863,7.483 C23.863,8.251 24.141,8.908 24.671,9.457 C25.201,10.005 25.870,10.251 26.651,10.251 ZM15.695,14.692 C14.998,14.692 14.412,14.445 13.938,13.925 C13.548,13.513 13.325,12.855 13.325,11.978 L13.325,3.180 C13.325,2.193 13.520,1.480 13.938,1.042 C14.412,0.521 14.998,0.274 15.723,0.274 C16.448,0.274 17.033,0.521 17.479,1.014 C17.897,1.480 18.092,2.193 18.092,3.180 L18.092,11.978 C18.092,12.745 17.897,13.375 17.479,13.869 C17.061,14.417 16.448,14.692 15.695,14.692 ZM10.036,14.692 C9.311,14.692 8.753,14.472 8.363,14.006 L4.739,9.566 L4.739,12.033 C4.739,12.745 4.628,13.267 4.377,13.677 C3.931,14.390 3.262,14.746 2.397,14.746 C1.617,14.746 1.003,14.500 0.585,13.978 C0.195,13.430 0.000,12.800 0.000,12.005 L0.000,2.906 C0.000,2.166 0.195,1.535 0.613,1.042 C1.031,0.549 1.645,0.274 2.397,0.274 C3.123,0.274 3.708,0.549 4.182,1.042 C4.461,1.315 4.628,1.618 4.683,1.892 C4.739,2.083 4.739,2.412 4.739,2.906 L4.739,5.181 L4.767,5.181 L7.443,1.343 C7.945,0.631 8.614,0.274 9.423,0.274 C10.092,0.274 10.649,0.494 11.123,0.960 C11.597,1.426 11.848,1.974 11.848,2.604 C11.848,3.070 11.708,3.481 11.458,3.865 L9.033,7.318 L11.987,11.018 C12.294,11.375 12.433,11.814 12.433,12.307 C12.433,12.965 12.211,13.513 11.736,13.978 C11.263,14.445 10.705,14.692 10.036,14.692 Z'
    />
  </SvgIcon>
);

export const IconGoogle = ({
  className,
  width = '21',
  height = '21',
  color = 'rgb(255, 255, 255)',
}) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 21 21'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      fillRule='evenodd'
      fill={color}
      d='M20.774,8.222 L16.592,8.222 L11.163,8.222 L11.163,12.181 L16.513,12.181 C16.032,13.467 15.118,14.541 13.948,15.227 L13.948,15.227 L13.948,15.227 C13.066,15.745 12.039,16.041 10.943,16.041 C8.392,16.041 6.217,14.435 5.372,12.180 L5.372,12.180 L5.372,12.180 C5.128,11.530 4.995,10.826 4.995,10.091 C4.995,9.414 5.108,8.764 5.316,8.158 L5.316,8.158 L5.316,8.158 C6.119,5.821 8.335,4.142 10.943,4.142 C12.098,4.142 13.176,4.471 14.088,5.042 L17.330,2.387 C15.597,0.948 13.371,0.083 10.943,0.083 C7.076,0.083 3.721,2.277 2.056,5.489 C1.341,6.867 0.937,8.432 0.937,10.091 C0.937,11.808 1.369,13.423 2.130,14.834 L2.130,14.834 L2.130,14.834 C3.820,17.970 7.133,20.100 10.943,20.100 C13.314,20.100 15.492,19.275 17.207,17.897 L17.207,17.896 L17.207,17.896 L17.207,17.896 L17.207,17.897 C18.970,16.479 20.243,14.475 20.730,12.181 C20.873,11.507 20.949,10.808 20.949,10.091 C20.949,9.452 20.889,8.827 20.774,8.222 Z'
    />
  </SvgIcon>
);

export const IconFacebook = ({
  className,
  width = '11',
  height = '22',
  color = 'rgb(255, 255, 255)',
}) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox='0 0 11 21'
    preserveAspectRatio='xMidYMid meet'
    className={className}
  >
    <path
      fillRule='evenodd'
      fill={color}
      d='M8.421,4.028 L10.303,4.028 L10.303,0.752 C9.978,0.707 8.862,0.606 7.562,0.606 C4.850,0.606 2.992,2.312 2.992,5.448 L2.992,8.334 L-0.001,8.334 L-0.001,11.996 L2.992,11.996 L2.992,21.212 L6.661,21.212 L6.661,11.997 L9.533,11.997 L9.989,8.334 L6.660,8.334 L6.660,5.811 C6.661,4.752 6.946,4.028 8.421,4.028 L8.421,4.028 Z'
    />
  </SvgIcon>
);

export const IconLock = ({ className, width = '40', height = '40', color = '#FEED00' }) => (
  <SvgIcon width={width} height={height} fill={color} className={className}>
    <circle opacity='0.6' cx='20' cy='20' r='20' fill='#03152F' />
    <path
      d='M25.7148 15.6655H24.764V13.7606C24.764 11.1324 22.6316 9 20.0034 9C17.3752 9 15.236 11.1324 15.236 13.7606V15.6655H14.2852C13.236 15.6655 12.3803 16.5212 12.3803 17.5705V27.0951C12.3803 28.1443 13.236 29 14.2852 29H25.7148C26.764 29 27.6197 28.1443 27.6197 27.0951V17.5705C27.6197 16.5212 26.764 15.6655 25.7148 15.6655ZM17.1409 13.7606C17.1409 12.1783 18.4177 10.9049 19.9966 10.9049C21.5756 10.9049 22.8523 12.1817 22.8523 13.7606V15.6655H17.1409V13.7606ZM25.7114 27.0951H14.2852V17.5705H25.7148V27.0951H25.7114ZM19.9966 24.0323C20.9304 24.0323 21.6944 23.2683 21.6944 22.3345C21.6944 21.4007 20.9304 20.6367 19.9966 20.6367C19.0628 20.6367 18.2988 21.4007 18.2988 22.3345C18.2988 23.2683 19.0628 24.0323 19.9966 24.0323Z'
      fill={color}
    />
  </SvgIcon>
);

export const IconDevice = ({
  className,
  width = '33',
  height = '28',
  color = 'rgb(254, 237, 0)',
}) => (
  <SvgIcon width={width} height={height} fill={color} className={className}>
    <path
      fillRule='evenodd'
      fill={color}
      d='M32.096,20.989 L32.096,22.558 L29.588,22.558 L29.588,22.552 L2.618,22.552 L2.618,22.558 L0.110,22.558 L0.110,20.027 L0.122,20.027 L0.122,2.532 L0.121,2.532 L0.121,0.000 L1.779,0.000 C1.780,0.000 1.780,0.000 1.781,0.000 L30.443,0.000 C30.443,0.000 30.443,0.000 30.444,0.000 L32.107,0.000 L32.107,1.678 C32.107,1.679 32.107,1.679 32.107,1.680 L32.107,20.878 C32.107,20.916 32.098,20.951 32.096,20.989 ZM29.588,2.532 L2.629,2.532 L2.629,20.027 L29.588,20.027 L29.588,2.532 ZM9.840,13.150 L7.332,13.150 L7.332,9.408 L9.840,9.408 L9.840,13.150 ZM14.855,13.150 L12.347,13.150 L12.347,9.408 L14.855,9.408 L14.855,13.150 ZM19.870,13.150 L17.363,13.150 L17.363,9.408 L19.870,9.408 L19.870,13.150 ZM24.885,13.150 L22.378,13.150 L22.378,9.408 L24.885,9.408 L24.885,13.150 ZM21.864,28.000 L10.364,28.000 L10.364,25.468 L21.864,25.468 L21.864,28.000 Z'
    />
  </SvgIcon>
);

export const IconSuccess = ({
  className,
  width = '56',
  height = '56',
  color = 'rgb(254, 237, 0)',
}) => (
  <SvgIcon width={width} height={height} fill={color} className={className} viewBox={`0 0 56 56`}>
    <path
      fillRule='evenodd'
      fill='rgb(254, 237, 0)'
      d='M28.000,0.000 C43.464,0.000 56.000,12.536 56.000,28.000 C56.000,43.464 43.464,56.000 28.000,56.000 C12.536,56.000 0.000,43.464 0.000,28.000 C0.000,12.536 12.536,0.000 28.000,0.000 Z'
    />
    <path
      fillRule='evenodd'
      fill='rgb(1, 21, 51)'
      d='M40.969,21.556 L25.414,36.998 L14.945,26.625 L17.206,24.380 L25.414,32.513 L38.707,19.316 L40.969,21.556 Z'
    />
  </SvgIcon>
);

export const IconMovie404 = ({ className, width = '104', height = '104', color = '#FEED00' }) => (
  <SvgIcon width={width} height={height} fill={color} className={className} viewBox={`0 0 104 104`}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M61 34C80.3258 34 96 49.6742 96 69C96 88.3258 80.3258 104 61 104C41.6742 104 26 88.3258 26 69C26 49.6742 41.6742 34 61 34Z'
      fill='#051F46'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M80.7247 0.447217L81.8811 0.16333L84.9374 13.3724L84.3262 14.4412L70.8456 17.6307L80.7247 0.447217ZM12.149 46.1029H12.1656V41.3937L17.6668 31.8251H29.3136L21.103 46.1029H30.9656L39.1762 31.8251H50.823L42.6124 46.1029H53.8628L62.0568 31.8251H73.7036L65.493 46.1029H76.1321L84.3262 31.8251H87.085V46.1029H87.1016V94.1633H12.149V46.1029ZM23.2011 53.1834H76.0991V87.0995H23.2011V53.1834ZM10.7613 30.2387C12.2316 30.2387 13.4211 31.441 13.4211 32.9272C13.4211 34.4135 12.2316 35.6158 10.7613 35.6158C9.29102 35.6158 8.10156 34.4135 8.10156 32.9272C8.10156 31.441 9.29102 30.2387 10.7613 30.2387ZM8.91106 17.4303L17.9477 15.2928L11.1578 27.166L8.91106 17.4303ZM29.2806 12.6043L42.7611 9.41471L32.882 26.5982L19.4014 29.7878L29.2806 12.621V12.6043ZM54.2923 6.67603L67.7728 3.48648L57.8937 20.67L44.4131 23.8595L54.2923 6.69273V6.67603Z'
      fill={color}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M59.9814 61.2386L56.7845 58.045L48.5188 66.3186L40.2365 58.045L37.0396 61.2386L45.3218 69.4956L37.0396 77.7692L40.2365 80.9627L48.5188 72.6892L56.7845 80.9627L59.9814 77.7692L51.6992 69.4956L59.9814 61.2386Z'
      fill='white'
    />
  </SvgIcon>
);

export const IconAmeriaBank = ({ className, width = '101', height = '16', color = '#69BA31' }) => (
  <SvgIcon width={width} height={height} fill={color} className={className} viewBox={`0 0 101 16`}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M90.4534 3.94244H91.7475C91.8012 3.94244 91.8448 3.98632 91.8448 4.04087V11.0764C91.8448 11.6178 91.4118 12.0563 90.8774 12.0572C90.563 12.0575 90.27 11.8944 90.0819 11.6394L86.2664 6.46945V11.9584C86.2664 12.013 86.2225 12.0572 86.1688 12.0572H84.863C84.8094 12.0572 84.7657 12.013 84.7657 11.9584V4.92294C84.7657 4.38125 85.1996 3.94214 85.7349 3.94214C86.0408 3.94214 86.3285 4.08831 86.5113 4.33588L90.3559 9.54143V4.04087C90.3559 3.98661 90.3995 3.94244 90.4534 3.94244ZM73.8087 7.12482C73.5605 7.44562 73.2189 7.65999 72.7835 7.76821V7.7685C73.318 7.86902 73.736 8.10087 74.0378 8.46408C74.3393 8.82728 74.4902 9.27944 74.4902 9.82024C74.4902 10.5158 74.225 11.0628 73.6941 11.4607C73.1633 11.8586 72.4399 12.0576 71.5234 12.0576H68.7322C68.2493 12.0576 67.8579 11.6615 67.8579 11.1728V4.82758C67.8579 4.33896 68.2493 3.94284 68.7322 3.94284H71.4206C72.2758 3.94284 72.95 4.12459 73.4422 4.4878C73.935 4.851 74.1811 5.34556 74.1811 5.97145C74.1811 6.41975 74.0569 6.80431 73.8087 7.12482ZM71.34 5.28744H69.3928V7.25794H71.34C71.737 7.25794 72.0485 7.16929 72.2738 6.99139C72.4988 6.81379 72.6116 6.56652 72.6116 6.24957C72.6116 5.94062 72.4988 5.70076 72.2738 5.53086C72.0485 5.36097 71.737 5.27973 71.34 5.28744ZM71.34 10.7127C71.8287 10.7207 72.2108 10.6279 72.4856 10.4346C72.7607 10.2413 72.8981 9.97086 72.8981 9.62307C72.8981 9.2907 72.7604 9.03009 72.4856 8.84063C72.2105 8.65117 71.8287 8.56044 71.34 8.56815H69.3928V10.7127H71.34ZM100.981 11.9018L97.8138 7.37379L100.747 4.10731C100.804 4.04387 100.76 3.94246 100.675 3.94246H99.1287C99.1011 3.94246 99.0751 3.95432 99.0566 3.97508L95.4658 7.98842V4.04149C95.4658 3.98694 95.4222 3.94276 95.3685 3.94276H94.0281C93.9742 3.94276 93.9309 3.98694 93.9309 4.04149V11.9591C93.9309 12.0136 93.9742 12.0575 94.0281 12.0575H95.3685C95.4225 12.0575 95.4658 12.0133 95.4658 11.9591V9.98234L96.7259 8.57963L99.2169 12.0172C99.2353 12.0424 99.2643 12.0575 99.2954 12.0575H100.902C100.981 12.0575 101.028 11.9674 100.982 11.9018H100.981ZM79.388 5.65533L76.6398 11.997C76.624 12.0329 76.5891 12.056 76.5504 12.056H75.2414C75.1711 12.056 75.1239 11.9831 75.1523 11.9179L78.2946 4.66681C78.7124 3.70291 80.0636 3.70291 80.4814 4.66681L83.6239 11.9179C83.6524 11.9831 83.6049 12.056 83.5349 12.056H82.2255C82.1869 12.056 82.1517 12.0329 82.1362 11.997L79.388 5.65533Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.48103 16H14.329C15.1455 16 15.81 15.3276 15.81 14.5009V1.49907C15.81 0.672448 15.1458 0 14.329 0H1.48103C0.664487 0 0 0.672448 0 1.49907V14.5009C0 15.3276 0.664194 16 1.48103 16ZM0.486646 1.49907C0.486646 0.944037 0.932567 0.492773 1.48103 0.492773H14.329C14.8774 0.492773 15.3236 0.944037 15.3236 1.49907V14.5009C15.3236 15.056 14.8771 15.5072 14.329 15.5072H1.48103C0.932567 15.5072 0.486646 15.056 0.486646 14.5009V1.49907ZM35.3652 4.57997C35.536 4.19224 35.9162 3.94262 36.3356 3.9425C36.9227 3.9425 37.3985 4.42401 37.3985 5.01819V11.9585C37.3985 12.0131 37.3552 12.0572 37.3013 12.0572H36.0872C36.0335 12.0572 35.9899 12.0131 35.9899 11.9585V6.23766L33.6891 11.5995C33.5461 11.9327 33.1849 12.1251 32.818 12.035C32.5866 11.9781 32.3994 11.8058 32.3041 11.5849L29.999 6.23766V11.9585C29.999 12.0131 29.9553 12.0572 29.9017 12.0572H28.699C28.6454 12.0572 28.6017 12.0131 28.6017 11.9585V5.01819C28.6017 4.42401 29.0775 3.9425 29.6647 3.9425H29.667C30.0851 3.9425 30.4645 4.19067 30.6362 4.57671L33.0117 9.91834L35.3652 4.57997ZM41.0187 10.701H45.4003C45.4542 10.701 45.4978 10.7452 45.4978 10.7998V11.9588C45.4978 12.0133 45.4542 12.0575 45.4003 12.0575H40.358C39.8752 12.0575 39.4838 11.6614 39.4838 11.1728V4.82749C39.4838 4.33887 39.8752 3.94275 40.358 3.94275H45.2629C45.3165 3.94275 45.3601 3.98663 45.3601 4.04119V5.20048C45.3601 5.25503 45.3168 5.29921 45.2629 5.29921H41.0187V7.30469H44.8161C44.8697 7.30469 44.9133 7.34858 44.9133 7.40313V8.56242C44.9133 8.61668 44.87 8.66086 44.8161 8.66086H41.0187V10.701ZM57.004 3.9425H55.6636C55.6097 3.9425 55.5663 3.98668 55.5663 4.04094V11.9585C55.5663 12.0131 55.6097 12.0572 55.6636 12.0572H57.004C57.0579 12.0572 57.1013 12.0131 57.1013 11.9585V4.04094C57.1013 3.98639 57.0576 3.9425 57.004 3.9425ZM52.5989 9.16021C52.4794 9.23996 52.3467 9.30756 52.2084 9.36508H52.2087L53.9833 11.9019C54.029 11.9674 53.983 12.0575 53.9039 12.0575H52.2971C52.2661 12.0575 52.2371 12.0424 52.2186 12.0172L50.5173 9.66929H50.5152H48.7055V11.9588C48.7055 12.0134 48.6618 12.0572 48.6079 12.0572H47.2675C47.2139 12.0572 47.1702 12.0134 47.1702 11.9588V4.82724C47.1702 4.33862 47.5617 3.9425 48.0445 3.9425H50.5149C51.5536 3.9425 52.3552 4.18593 52.9206 4.67277C53.4855 5.15991 53.7682 5.84777 53.7682 6.73637C53.7682 7.37027 53.6326 7.91137 53.3616 8.35938C53.1685 8.6784 52.9077 8.95414 52.5989 9.16021ZM50.5146 8.30126C51.095 8.30126 51.538 8.17347 51.8436 7.91849V7.91879C52.1489 7.6641 52.3018 7.28547 52.3018 6.78292C52.3018 6.28837 52.1489 5.91745 51.8436 5.66988C51.5377 5.4226 51.095 5.29896 50.5146 5.29896H48.7049V8.30126H50.5146ZM20.4752 11.997L23.2236 5.65533L25.9718 11.997C25.9874 12.0329 26.0225 12.056 26.0609 12.056H27.3703C27.4403 12.056 27.4877 11.9831 27.4593 11.9179L24.3168 4.66681C23.899 3.70291 22.5477 3.70291 22.1299 4.66681L18.9877 11.9179C18.9593 11.9831 19.0064 12.056 19.0768 12.056H20.3858C20.4245 12.056 20.4596 12.0329 20.4752 11.997ZM62.4797 5.65533L59.7315 11.997C59.7157 12.0329 59.6808 12.056 59.6421 12.056H58.3331C58.2628 12.056 58.2156 11.9831 58.244 11.9179L61.3863 4.66681C61.8041 3.70291 63.1553 3.70291 63.5731 4.66681L66.7156 11.9179C66.744 11.9831 66.6966 12.056 66.6266 12.056H65.3172C65.2785 12.056 65.2434 12.0329 65.2279 11.997L62.4797 5.65533ZM5.15669 11.997L7.90487 5.65533L10.6531 11.997C10.6686 12.0329 10.7037 12.056 10.7424 12.056H12.0518C12.1218 12.056 12.1693 11.9831 12.1408 11.9179L8.99829 4.66681C8.58049 3.70291 7.22925 3.70291 6.81146 4.66681L3.66891 11.9179C3.64079 11.9831 3.68796 12.056 3.75798 12.056H5.06703C5.10571 12.056 5.14086 12.0329 5.15639 11.997H5.15669Z'
      fill={color}
    />
  </SvgIcon>
);

export const IconCard = ({ className, width = '20', height = '16', color = 'white' }) => (
  <SvgIcon width={width} height={height} fill={color} className={className} viewBox={`0 0 20 16`}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.5662 15H1.43592C1.05658 15 0.690098 14.8593 0.422203 14.6061C0.152164 14.3549 0 14.0132 0 13.6555V2.35257C0 1.99483 0.150021 1.65116 0.42006 1.39793C0.690098 1.1447 1.05444 1 1.43592 1H18.5662C18.9477 1 19.312 1.1447 19.5821 1.39994C19.85 1.65317 20.0021 1.99684 20 2.35458V13.6555C20 14.0112 19.8478 14.3529 19.5799 14.6061C19.312 14.8573 18.9477 15 18.5662 15ZM1.43592 13.8745H18.5662C18.6284 13.8745 18.6862 13.8524 18.7312 13.8102C18.7741 13.77 18.7998 13.7138 18.7998 13.6555V11.0267H1.20231V13.6555C1.20231 13.7138 1.22803 13.768 1.27089 13.8082C1.31376 13.8484 1.37377 13.8725 1.43377 13.8725L1.43592 13.8745ZM18.5662 2.12748H1.43592C1.37162 2.1315 1.31376 2.15762 1.27089 2.20184C1.22803 2.24605 1.20446 2.30233 1.20446 2.36262V9.89923H18.7998V2.35257C18.7977 2.29429 18.7719 2.24002 18.7291 2.19782C18.6862 2.15561 18.6284 2.1315 18.5662 2.12748ZM5.83797 5.13207H3.47621V4.00459H5.83797V5.13207ZM7.03814 5.13207H9.3999V4.00459H7.03814V5.13207ZM12.9618 5.13207H10.6001V4.00459H12.9618V5.13207ZM14.1641 5.13207H16.5259V4.00459H14.1641V5.13207Z'
      fill={color}
    />
  </SvgIcon>
);

export const IconAudioSubTitle = ({
  className,
  width = '32',
  height = '32',
  color = '#ACCAF8',
}) => (
  <SvgIcon width={width} height={height} fill={color} className={className} viewBox={`0 0 32 32`}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M29.3334 4.15039V22.9716H24.459V27.8497H20.8089L17.5631 24.6039L15.9311 22.9716H2.66675V4.15039H29.3334ZM26.7526 6.73079H5.24753V20.3908H17.0001L21.2128 24.6039L21.8783 25.269V20.3908H26.7526V6.73079ZM23.2586 15.04V17.6207H15.6201V15.04H23.2586ZM12.6732 15.04V17.6207H8.74159V15.04H12.6732ZM16.0022 9.50054V12.0813H8.74159V9.50054H16.0022ZM23.2586 9.50054V12.0813H18.9495V9.50054H23.2586Z'
      fill={color}
    />
  </SvgIcon>
);

export const IconAudioQuality = ({ className, width = '32', height = '32', color = '#ACCAF8' }) => (
  <SvgIcon width={width} height={height} fill={color} className={className} viewBox={`0 0 32 32`}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.2199 12.2821H9.63209V10.1325H2.66675V7.54932H9.63209V5.39514H12.2199V7.54932V10.1325V12.2821ZM14.8031 7.54932H29.3334V10.1325H14.8031V7.54932ZM17.1971 21.8675H2.66675V24.4507H17.1971V21.8675ZM19.7803 19.7179H22.3681V21.8675H29.3334V24.4507H22.3681V26.6048H19.7803V24.4507V21.8675V19.7179Z'
      fill={color}
    />
  </SvgIcon>
);

export const IconAudioSpeed = ({ className, width = '32', height = '32', color = '#ACCAF8' }) => (
  <SvgIcon width={width} height={height} fill={color} className={className} viewBox={`0 0 32 32`}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M27.1389 15.1696L28.7723 12.6943C29.9757 14.8265 30.6666 17.2881 30.6666 19.9098C30.6666 21.4014 30.4424 22.8427 30.0306 24.197C29.7561 25.0892 29.3992 25.9494 28.9691 26.7593H3.03075C2.60066 25.9494 2.24377 25.0892 1.96924 24.197C1.55745 22.8427 1.33325 21.4014 1.33325 19.9098C1.33325 11.8066 7.89905 5.24084 16.0022 5.24084C18.5233 5.24084 20.898 5.87683 22.9706 7.0024L20.509 8.67702C19.1135 8.11424 17.5945 7.80311 16.0022 7.80311C9.3266 7.80311 3.89551 13.2342 3.89551 19.9098C3.89551 21.4197 4.17462 22.8656 4.6825 24.197H27.3173C27.8252 22.8656 28.1043 21.4197 28.1043 19.9098C28.1043 18.2306 27.7612 16.6292 27.1389 15.1696ZM27.0611 8.64042L18.1939 22.0694L13.7694 17.709L27.0611 8.64042Z'
      fill={color}
    />
  </SvgIcon>
);

export const IconVivaCell = ({ className, width = '34', height = '16' }) => (
  <SvgIcon width={width} height={height} fill='none' className={className} viewBox={`0 0 34 16`}>
    <g clipPath='url(#clip0_1002_127)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.8294 10.4677L16.4683 3.81403H14.5921C15.8137 6.19101 17.0494 8.59537 18.2544 10.9402C18.7212 11.8499 19.2623 12.2345 19.9672 12.2375C20.6722 12.2345 21.2132 11.8499 21.6801 10.9402C22.8852 8.59549 24.1208 6.19101 25.3424 3.81403H23.4662L20.1052 10.4677C20.0448 10.5872 19.8897 10.5872 19.8293 10.4677H19.8294ZM28.6029 5.53218L25.242 12.1858H23.3657C24.5873 9.80886 25.8231 7.40449 27.028 5.05968C27.4949 4.15007 28.036 3.76547 28.7409 3.76248C29.4459 3.76547 29.987 4.15007 30.4538 5.0598C31.6588 7.40449 32.8946 9.80898 34.1162 12.186H32.2399L28.8789 5.5323C28.8186 5.41283 28.6634 5.41283 28.6031 5.5323L28.6029 5.53218ZM11.8183 12.1858V3.81403H13.5241V12.1858H11.8183ZM5.23723 10.4677L1.87625 3.81403H0C1.22162 6.19101 2.45734 8.59537 3.66234 10.9402C4.1291 11.8499 4.67025 12.2345 5.37523 12.2375C6.08022 12.2345 6.62125 11.8499 7.08813 10.9402C8.29312 8.59537 9.52885 6.19101 10.7505 3.81403H8.87421L5.51324 10.4677C5.45285 10.5872 5.29774 10.5872 5.23735 10.4677H5.23723Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_1002_127'>
        <rect width='34' height='16' fill='white' />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const IconArrowRight = ({ className, color = '#ACCAF8', width = '24', height = '24' }) => (
  <SvgIcon width={width} height={height} fill='none' className={className} viewBox={`0 0 24 24`}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.82374 6.42374L15.3999 11.9999L9.82374 17.5763L8.5999 16.3511L12.9513 11.9999L8.5999 7.64849L9.82374 6.42374Z'
      fill={color}
    />
  </SvgIcon>
);

export const IconWeb = ({ className, color = '#fff', width = '32', height = '32' }) => (
  <SvgIcon width={width} height={height} fill='none' className={className} viewBox={`0 0 32 32`}>
    <path
      d='M16 5C9.92531 5 5 9.92531 5 16C5 22.0747 9.92531 27 16 27C22.0747 27 27 22.0747 27 16C27 9.92531 22.0702 5 16 5ZM25.3343 15.1873H21.1094C20.9971 11.8829 20.2069 8.98694 19.0306 7.13265C22.4698 8.31347 25.0065 11.4339 25.3298 15.1873H25.3343ZM16 25.3747C15.3265 25.3747 14.5004 24.4992 13.8449 23.0894C13.0727 21.4371 12.6012 19.1833 12.5114 16.8082H19.4886C19.3 21.9894 17.329 25.3747 16 25.3747ZM12.5114 15.1873C12.7 10.0061 14.671 6.62082 16 6.62082C16.6735 6.62082 17.4996 7.49633 18.1551 8.90612C18.9273 10.5584 19.3988 12.8122 19.4886 15.1873H12.5114ZM12.9649 7.13265C11.7931 8.98245 10.9984 11.8829 10.8861 15.1873H6.66122C6.98449 11.4339 9.52571 8.31347 12.9604 7.13265H12.9649ZM6.66122 16.8082H10.8861C10.9984 20.1127 11.7886 23.0086 12.9649 24.8629C9.52571 23.682 6.98898 20.5616 6.66571 16.8082H6.66122ZM19.0306 24.8629C20.2024 23.0131 20.9971 20.1127 21.1094 16.8082H25.3343C25.011 20.5616 22.4698 23.682 19.0351 24.8629H19.0306Z'
      fill={color}
    />
  </SvgIcon>
);

export const IconIos = ({ className, color = '#fff', width = '32', height = '32' }) => (
  <SvgIcon width={width} height={height} fill='none' className={className} viewBox={`0 0 32 32`}>
    <path
      d='M20.3563 8.9319C21.2668 8.9319 24.0275 9.13193 25.6872 11.627L26.076 12.2119L25.5165 12.6345C24.7171 13.2383 23.2587 14.3397 23.2587 16.5213C23.2587 19.1051 24.9104 20.0988 25.704 20.5768C26.0542 20.7877 26.4168 21.0052 26.4168 21.481C26.4168 21.7916 23.9403 28.4615 20.3439 28.4615C19.4639 28.4615 18.8419 28.1967 18.2932 27.9632C17.738 27.7267 17.2591 27.5231 16.4677 27.5231C16.0666 27.5231 15.5594 27.7129 15.0224 27.9145C14.2885 28.1886 13.4579 28.5 12.5153 28.5H12.4906C8.71042 28.4782 5.5835 20.7535 5.5835 16.8195C5.5835 10.3933 10.3992 8.98642 12.2552 8.98642C13.0916 8.98642 13.9847 9.31522 14.7724 9.60618C15.3233 9.80914 15.893 10.0187 16.2098 10.0187C16.3995 10.0187 16.8464 9.84042 17.241 9.68405C18.0825 9.34869 19.1296 8.9319 20.349 8.9319H20.3563ZM20.73 3.5C20.8237 6.88065 18.4085 9.22599 15.9961 9.0789C15.5986 6.38102 18.4082 3.5 20.73 3.5Z'
      fill={color}
    />
  </SvgIcon>
);

export const IconAndroid = ({ className, color = '#fff', width = '32', height = '32' }) => (
  <SvgIcon width={width} height={height} fill='none' className={className} viewBox={`0 0 32 32`}>
    <path
      d='M22.0757 13.2183L24.1416 9.63066C24.2582 9.42953 24.1877 9.17405 23.9898 9.05718C23.7919 8.94031 23.5343 9.00825 23.4205 9.20938L21.3274 12.8432C19.7306 12.1121 17.9331 11.7044 16 11.7044C14.0669 11.7044 12.2694 12.1121 10.6726 12.8432L8.57953 9.20938C8.46295 9.00825 8.2081 8.94031 8.00747 9.05718C7.80685 9.17405 7.73907 9.42953 7.85565 9.63066L9.92155 13.2183C6.35908 15.1534 3.94614 18.7683 3.54761 23H28.4524C28.0539 18.7682 25.6409 15.1534 22.0758 13.2183H22.0757ZM10.2821 19.4939C9.70466 19.4939 9.23834 19.0237 9.23834 18.4475C9.23834 17.8686 9.70738 17.4011 10.2821 17.4011C10.8596 17.4011 11.3259 17.8713 11.3259 18.4475C11.3287 19.0237 10.8596 19.4939 10.2821 19.4939ZM21.7152 19.4939C21.1377 19.4939 20.6714 19.0237 20.6714 18.4475C20.6714 17.8686 21.1404 17.4011 21.7152 17.4011C22.2926 17.4011 22.759 17.8713 22.759 18.4475C22.7617 19.0237 22.2926 19.4939 21.7152 19.4939Z'
      fill={color}
    />
  </SvgIcon>
);

export const IconTV = ({ className, color = '#fff', width = '32', height = '32' }) => (
  <SvgIcon width={width} height={height} fill='none' className={className} viewBox={`0 0 32 32`}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.13804 22.653C3.36642 22.873 3.65873 22.9943 3.96476 22.9943H28.0308C28.6748 22.9943 29.2001 22.4823 29.2001 21.8492V6.14962C29.2001 5.51643 28.6748 5 28.0308 5H3.96476C3.65417 5 3.36185 5.12125 3.13804 5.34578C2.9188 5.55236 2.80005 5.83976 2.80005 6.14962V21.8492C2.80005 22.1545 2.9188 22.4419 3.13804 22.653ZM27.5421 21.3776H4.44891V6.62115H27.5421V21.3776ZM10.1949 26.1871C10.1949 26.6362 10.5603 27 11.017 27H20.9878C21.44 27 21.81 26.6317 21.81 26.1871C21.81 25.7426 21.4446 25.3788 20.9878 25.3788H11.017C10.5648 25.3788 10.1949 25.7381 10.1949 26.1871Z'
      fill={color}
    />
  </SvgIcon>
);
